import { render, staticRenderFns } from "./PrintFishkaDlg.vue?vue&type=template&id=30fa1b44&"
import script from "./PrintFishkaDlg.vue?vue&type=script&lang=js&"
export * from "./PrintFishkaDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports